import { c as _c } from "react/compiler-runtime";
import { PAGE_TEMPLATES_API } from 'modules/funnels/funnel/api/page-templates-api';
import { PageTemplateLimitType } from 'modules/funnels/funnel/components/page-template-selector/page-template-pagination';
import { FunnelPageTypeEnum } from 'modules/funnels/funnel/enums/funnel-page-type-enum';
import { FunnelPageTemplatesApiInterface } from 'modules/funnels/funnel/types/funnel-page-template-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { PaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
interface UsePageTemplatesProps {
  type?: FunnelPageTypeEnum;
  pagination: PaginationInterface;
  limit?: PageTemplateLimitType;
}
export function usePageTemplates(t0) {
  const $ = _c(8);
  const {
    type,
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== type || $[4] !== user) {
    t2 = () => {
      if (user && type && pagination.startFromId === undefined && limit) {
        return `${PAGE_TEMPLATES_API}/${type}?pagination[limit]=${limit}`;
      } else {
        if (user && type && pagination.startFromId && limit) {
          return `${PAGE_TEMPLATES_API}/${type}?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = type;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: pageTemplates
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== pageTemplates) {
    t3 = {
      pageTemplates
    };
    $[6] = pageTemplates;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}